'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var cx = require('classnames');
var DownloadIcon = require('../alloy-icon/DownloadIcon.js');
var fileDropZone_module = require('./file-drop-zone.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var FileDropZone = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.icon, Icon = _c === void 0 ? DownloadIcon.default : _c, iconClassname = _a.iconClassname, iconProps = _a.iconProps, message = _a.message, onFileDrop = _a.onFileDrop;
    var _d = react.useState(false), isDragging = _d[0], setIsDragging = _d[1];
    var dragCounter = react.useRef(0);
    /**
     * If there are child elements inside our drag and drop div, the drag events will be fired
     * on those nested elements as well (causing flickering from setState to be called each time),
     * so we want to keep track of the how many elements deep our cursor is, and only set call
     * setIsDragging(false) once our cursor is all the way out. We will add a counter
     * to do this. We increment it on dragIn, decrement it on dragOut.
     * https://medium.com/@650egor/simple-drag-and-drop-file-upload-in-react-2cb409d88929
     */
    var handleDragIn = react.useCallback(function (e) {
        var _a;
        dragCounter.current++;
        // We have to iterate through the DataTransferItemList. Cannot read length directly from it.
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
        var containsFile = false;
        var data = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.items;
        if (data) {
            for (var i = 0; i < data.length; i += 1) {
                if (data[i].kind == 'file') {
                    containsFile = true;
                }
            }
        }
        if (containsFile) {
            setIsDragging(true);
        }
    }, []);
    var handleDragOut = react.useCallback(function (e) {
        dragCounter.current--;
        if (dragCounter.current > 0)
            return;
        setIsDragging(false);
    }, [dragCounter]);
    var handleDrop = react.useCallback(function (e) {
        var _a;
        dragCounter.current = 0;
        if (((_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) && e.dataTransfer.files.length > 0) {
            setIsDragging(false);
            onFileDrop(e.dataTransfer.files);
        }
    }, [onFileDrop]);
    react.useEffect(function () {
        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }
        var preventDefaultOn = ['dragenter', 'dragover', 'dragleave', 'drop'];
        preventDefaultOn.forEach(function (eventName) {
            document.addEventListener(eventName, preventDefaults, false);
        });
        document.addEventListener('dragenter', handleDragIn, false);
        document.addEventListener('dragleave', handleDragOut, false);
        document.addEventListener('drop', handleDrop, false);
        return function () {
            preventDefaultOn.forEach(function (eventName) {
                document === null || document === void 0 ? void 0 : document.removeEventListener(eventName, preventDefaults, false);
            });
            document === null || document === void 0 ? void 0 : document.removeEventListener('dragenter', handleDragIn, false);
            document === null || document === void 0 ? void 0 : document.removeEventListener('dragleave', handleDragOut, false);
            document === null || document === void 0 ? void 0 : document.removeEventListener('drop', handleDrop, false);
        };
    }, [handleDragIn, handleDragOut, handleDrop]);
    var commonClasses = 'd-flex flex-column justify-content-center align-items-center';
    return (jsxRuntime.jsxs("div", tslib.__assign({ "data-testid": "fileDropZone", className: "position-relative" }, { children: [jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default((_b = {},
                    _b["".concat(fileDropZone_module.default['drop-zone'], " position-fixed ").concat(commonClasses, " m-3")] = isDragging,
                    _b), className) }, { children: isDragging ? (jsxRuntime.jsxs("div", tslib.__assign({ className: commonClasses }, { children: [jsxRuntime.jsx(Icon, tslib.__assign({ height: 48, width: 52, className: iconClassname }, iconProps)), message && message] }))) : null })), children] })));
};
var FileDropZone$1 = FileDropZone;

exports.default = FileDropZone$1;
//# sourceMappingURL=FileDropZone.js.map
